import { Grid, Typography, Stack, Box, Divider } from "@mui/material";
import { grey } from "@mui/material/colors";
import {
  getCellColor,
  getCellFontWeight,
  getCellVariant,
  getDirection,
  getIsYang,
} from "../StyleControl";
import { Fragment } from "react";

function getKey(name) {
  return name + Math.random() * 10000;
}

export default function BaZiBaseRow({ data, dark }) {
  const name = data[0];
  let columns = data.length;

  return (
    <Grid
      container
      columns={columns}
      spacing={0}
      key={name}
      alignItems="flex-start"
      justifyContent="space-between"
      sx={{
        backgroundColor: dark && grey[100],
        minWidth: columns * 60, // 每列最小60px，确保可以横向滚动
      }}
    >
      {data.map((item, idx) => {
        let box = null;

        const isTitle = item === name;
        const fontStyle = getIsYang(item) ? null : "italic";

        if (typeof item === "string" || item instanceof String) {
          box = (
            <Typography
              align="center"
              fontWeight={getCellFontWeight(name, item)}
              color={getCellColor(name, item)}
              variant={getCellVariant(name, item)}
              sx={{ fontStyle: isTitle ? null : fontStyle }}
            >
              {item}
            </Typography>
          );
        } else if (Array.isArray(item)) {
          box = (
            <Stack direction={getDirection(name)} justifyContent={"center"}>
              {item.map((value) => (
                <Typography
                  key={getKey(name)}
                  align="center"
                  color={getCellColor(name, value)}
                >
                  {value}
                </Typography>
              ))}
            </Stack>
          );
        } else {
          box = <Box></Box>;
        }

        return (
          <Fragment key={idx}>
            <Grid
              size={1}
              key={getKey(name)}
              alignItems={"flex-start"}
              alignContent={"flex-start"}
            >
              {box}
            </Grid>
            {/* 在第五个和第六个之间添加分割线 */}
            {idx === 4 && (
              <Divider
                orientation="vertical"
                flexItem
                sx={{
                  mr: "-1px", // 解决布局问题的关键
                  backgroundColor: "rgba(0, 0, 0, 0.12)",
                }}
              />
            )}
          </Fragment>
        );
      })}
    </Grid>
  );
}

function GanZhiRow({ data }) {
  const name = data[0];

  return (
    <Grid
      container
      columns={5}
      spacing={0}
      alignItems={"flex-start"}
      justifyContent={"start"}
    >
      {data.map((item) => {
        const isTitle = item.length === 2;
        const fontStyle = getIsYang(item) ? null : "italic";
        return (
          <Grid key={getKey(name)} size={1}>
            <Typography
              align="center"
              fontWeight={isTitle ? null : "bold"}
              color={getCellColor(name, item)}
              variant={isTitle ? "body1" : "h5"}
              sx={{ fontStyle: isTitle ? null : fontStyle }}
            >
              {item}
            </Typography>
          </Grid>
        );
      })}
    </Grid>
  );
}

export { GanZhiRow };
